"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const errors_1 = require("@seneca/errors");
/**
 * Thrown when a function is called with an invalid mandatory parameter
 * @param {string} paramName
 */
class InvalidParamError extends errors_1.ExtendableError {
    constructor(paramName, paramValue, reason) {
        super(`invalid ${paramName}${paramValue ? ` :: ${paramValue}` : ''}${reason ? ` because ${reason}` : ''}`);
        this.paramName = paramName;
        this.paramValue = paramValue;
        this.reason = reason;
    }
}
exports.default = InvalidParamError;
